import { render, staticRenderFns } from "./pengawas.vue?vue&type=template&id=42249f2f"
import script from "./pengawas.vue?vue&type=script&lang=js"
export * from "./pengawas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports